import React from 'react';
import styled from 'styled-components';
import {
  HeadlineOne,
  HeadlineTwo,
  Paragraph,
  WrapperCenter,
} from 'components/atoms/SectionWrapper.style';
import OzeCounter from '../OzeCounters/OzeWrapper';

const OzeFarmDesc = () => (
  <>
    <WrapperCenter>
      <HeadlineOne>OFERTA OZE:</HeadlineOne>
      <Paragraph>
        Elgreen Oze oferuje dla swoich klientów kompleksową obsługę w zakresie:
        <ol>
          <li>
            {' '}
            Farmy fotowoltaiczne i magazyny energii:
            <ul>
              <li>
                Analiza gruntów pod farmy fotowoltaiczne, farmy wiatrowe i
                magazyny energii
              </li>

              <li>
                Analizy i ekspertyzy z zakresu infrastruktury sieci
                energetycznych
              </li>

              <li>
                Kompleksowe projektowanie budowy farm fotowoltaicznych, farm
                wiatrowych i magazynów energii wraz z infrastrukturą
                towarzyszącą
              </li>

              <li>
                Projekty przyłączy, tras kablowych wraz z uzgodnieniami z
                Zakładem Energetycznym
              </li>

              <li>
                Budowa farm fotowoltaicznych, wiatrowych i przemysłowych
                magazynów energii pod klucz
              </li>

              <li>
                Obsługa serwisowa farm fotowoltaicznych, farm wiatrowych i
                magazynów energii
              </li>

              <li>
                Projektowanie na bazie kamieni milowych (Co Development
                Milestones)
              </li>
            </ul>
          </li>
          <br />

          <li>
            Audyty energetyczne:
            <ul>
              <li>
                Analiza funkcjonowania obiektu w celu sprawdzenia możliwości
                wygenerowania oszczędności dla inwestora
              </li>
              <li>
                Analiza parametrów sieci wewnętrznej obiektu uzyskiwana dzięki
                podpięciu analizatora parametrów sieci w RG obiektu
              </li>
              <li>
                {' '}
                Przygotowanie kompleksowego rozwiązania mającego na celu
                obniżenie kosztów stałych takich jak energia elektryczna, gaz,
                moc bierna. W skład narzędzi jakich używamy do uzyskania
                satysfakcjonujących efektów wchodzą: budowa instalacji
                fotowoltaicznej, baterie kompensacyjne w celu redukcji mocy
                biernej, magazyny energii, zmiana dostawcy prądu i gazu,
                termomodernizacja obiektu, wymiana źródeł ciepła
              </li>
            </ul>
          </li>
          <br />
          <li>
            Fotowoltaika i Pompy Ciepłą:
            <ul>
              <li>
                Audyt techniczny w celu sprawdzenia możliwości technicznych
                obiektu oraz zapotrzebowania energetycznego
              </li>
              <li>
                Projekt instalacji wraz ze wszystkimi uzgodnieniami i
                pozwoleniami w oparciu o przygotowany raport wynikający z audytu
              </li>
              <li>Dostawa podzespołów</li>
              <li>Montaż, konfiguracja, uruchomienie i monitoring</li>
              <li>Obsługa serwisowa</li>
            </ul>
          </li>
        </ol>
      </Paragraph>
      <HeadlineTwo>
        Zapraszamy do kontaktu z naszym działem realizacji w celu umówienia
        spotkania celowego!
      </HeadlineTwo>
      {/* </OfferWrapper> */}
    </WrapperCenter>
  </>
);

export default OzeFarmDesc;
